// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MBwO","newExpiryDate":"styles_newExpiryDate__1-8ix","footer":"styles_footer__28BSW"};